import { css } from "@emotion/react";

import theme from "../../styles/theme";
import { grey, greyLight, greySecondary, red, white } from "../../styles/variables";

const { spacing } = theme;

export const dialog = css`
  .MuiDialog-paper {
    background-color: transparent;
    box-shadow: none;
  }
`;

export const cardHeader = css`
  padding: ${spacing(2.5, 2.5, 0)};

  .MuiTypography-root {
    font-size: 18px;
    font-weight: bold;
  }
`;

export const cardContent = css`
  &:last-child {
    padding: ${spacing(2, 2.5)};
  }
`;

export const labelBlock = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${spacing(1)}px;
`;

export const codeBlock = css`
  padding: ${spacing(2)}px;
  width: 100%;
  border: none;
  border-radius: 4px;
  background: ${greyLight};
  resize: none;
`;

export const redeemCodeCard = css`
  &:last-child {
    padding: ${spacing(2, 0)};
  }
`;

export const section = css`
  display: flex;
  align-items: center;

  &.MuiGrid-item {
    padding-right: ${spacing(3)}px;
    padding-left: ${spacing(3)}px;
  }
`;

export const inputLabel = css`
  font-size: 12px;
`;

export const redeemCodeLabel = css`
  font-weight: bold;
  margin-right: ${spacing(2.5)}px;
`;

export const redeemCodeInput = css`
  input::placeholder {
    font-size: 14px;
    color: ${grey};
    opacity: 1;
  }
`;

export const redeemCodeSection = css`
  > div {
    width: 100%;
  }
`;

export const redeemCodeList = css`
  max-height: 127px;
  overflow-y: auto;

  &.MuiGrid-item {
    padding-right: ${spacing(3)}px;
    padding-left: ${spacing(3)}px;
  }
`;

export const buttonSection = css`
  display: flex;
  justify-content: center;

  &.MuiGrid-item {
    padding-top: ${spacing(2)}px;
  }
`;

export const buttonBorderSection = css`
  border-top: 2px solid ${greySecondary};
`;

export const button = css`
  width: 28.7%;
  height: 40px;
  margin-right: ${spacing(2)}px;

  &:last-of-type {
    margin-right: 0;
  }
`;

export const disabled = css`
  .MuiInput-underline {
    &::before,
    &:hover:not(.Mui-disabled)::before,
    &::after,
    &.Mui-focused::after {
      border-color: ${greySecondary};
    }
  }
`;

export const disabledLast = css`
  &:last-of-type {
    .MuiInput-underline {
      &::before,
      &:hover:not(.Mui-disabled)::before,
      &::after,
      &.Mui-focused::after {
        border-width: 0;
      }
    }
  }
`;

export const guide = css`
  text-align: center;
  font-weight: normal;
`;

export const exclamationIcon = css`
  width: 16px;
  height: 16px;
  border-radius: 4px;
  background-color: ${red};
  color: ${white};
  vertical-align: middle;
`;
